import React, { useEffect, useRef, useState } from 'react'
import { cn } from '../../lib/utils'

const EXIT_MS = 160

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

const AccountContentSwitch = ({ transitionKey, children, className }) => {
  const childrenRef = useRef(children)
  const displayedKeyRef = useRef(transitionKey)
  const [displayed, setDisplayed] = useState({
    key: transitionKey,
    children,
    phase: 'idle'
  })

  childrenRef.current = children

  useEffect(() => {
    if (transitionKey === displayedKeyRef.current) {
      setDisplayed(current => ({ ...current, children }))
    }
  }, [children, transitionKey])

  useEffect(() => {
    if (transitionKey === displayedKeyRef.current) return

    if (prefersReducedMotion()) {
      displayedKeyRef.current = transitionKey
      setDisplayed({
        key: transitionKey,
        children: childrenRef.current,
        phase: 'enter'
      })
      return
    }

    setDisplayed(current => ({ ...current, phase: 'exit' }))

    const timeoutId = window.setTimeout(() => {
      displayedKeyRef.current = transitionKey
      setDisplayed({
        key: transitionKey,
        children: childrenRef.current,
        phase: 'enter'
      })
    }, EXIT_MS)

    return () => window.clearTimeout(timeoutId)
  }, [transitionKey])

  return (
    <div
      className={cn(
        displayed.phase === 'exit'
          ? 'account-panel-exit'
          : displayed.phase === 'enter'
          ? 'account-panel-enter'
          : null,
        className
      )}
    >
      {displayed.children}
    </div>
  )
}

export default AccountContentSwitch
